// Route-def transform applied to EVERY entry in context.js's merged `pages`
// map — stamps the landmark the shell's SkipToMain link (app.js) needs to be
// a real accessibility skip-link rather than a dead keyboard-only jump.
//
// Split into its own dependency-free file (rather than staying inline in
// context.js) so it's unit-testable: context.js's own import chain pulls in
// the entire canvas/marketplace/preview eager slice + sharedLibraries.js,
// which drags in CSS imports plain `node --test` can't resolve — importing
// context.js itself in a test fails on "Unknown file extension .css" before
// a single assertion runs (verified live). This file has zero imports, so it
// tests in isolation.
//
// Two stamps, both merge-safe (a route def's own value always wins):
//   - `attr.id = 'main-content'` — the skip link's `href="#main-content"`
//     fragment target. Without a resolvable id the link is inert for
//     keyboard users AND axe's `region` skip-link exemption doesn't apply
//     (MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09).
//   - `role: 'main'` (A11Y-1 item 3, tickets/sonnet.md 2026-08-14) — the
//     `id` alone resolved the *jump*, but landed on whatever plain tag the
//     route rendered as (a `<div>`), not a semantic landmark, so a screen
//     reader's "jump to main region" navigation never found it even though
//     the visual/keyboard jump worked.
//
// The natural home for both — declaring `content: { attr: { id }, role }` on
// the app root — WIPES the shell's sibling children at boot (live-verified:
// root renders only `content`; framework bug, ticketed in tickets/smbls.md
// 2026-08-10), so the route map is the clean project-side choke point
// instead of 80+ individual page defs each remembering a landmark role.
export const anchorMainContent = (def) =>
  def && typeof def === 'object'
    ? { role: 'main', ...def, attr: { id: 'main-content', ...(def.attr || {}) } }
    : def
